(()=>{
'use strict';
const $=(s,r=document)=>r.querySelector(s);
const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const num=v=>Number(v||0).toLocaleString();
const stored=(k)=>{try{return localStorage.getItem(k)||''}catch{return''}};
const store=(k,v)=>{try{if(v)localStorage.setItem(k,String(v));}catch{}};
const query=()=>new URLSearchParams(location.search||'');
function withContext(base,school,returnTo){
  if(!base)return '#';
  const u=new URL(base,location.origin);
  if(school?.school_slug){u.searchParams.set('team',school.school_slug);u.searchParams.set('team_slug',school.school_slug)}
  if(school?.school_id)u.searchParams.set('school_id',school.school_id);
  if(returnTo)u.searchParams.set('return_to',returnTo);
  u.searchParams.set('game_center',location.pathname);
  return u.origin===location.origin?u.pathname+u.search+u.hash:u.toString();
}
async function init(root){
  if(!window.supabase?.createClient){root.textContent='Supabase client did not load.';return}
  const url=root.dataset.supabaseUrl||'';
  const key=root.dataset.supabaseKey||'';
  if(!url||!key){root.textContent='Add the Supabase URL and publishable key in section settings.';return}
  const sb=window.FanScoreSupabaseClient||window.supabase.createClient(url,key,{auth:{persistSession:true,autoRefreshToken:true,detectSessionInUrl:false}});
  window.FanScoreSupabaseClient=sb;
  const state={sb,session:null,user:null,schools:[],school:null,catalog:[]};
  const home=root.dataset.homeUrl||'/pages/hall-of-fan';
  const fanscore=root.dataset.fanscoreUrl||'/pages/fanscore-home';
  root.querySelectorAll('[data-hof-gc-home]').forEach(a=>a.href=home);
  root.querySelectorAll('[data-hof-gc-fanscore]').forEach(a=>a.href=fanscore);
  root.querySelectorAll('[data-hof-gc-fanworks]').forEach(a=>a.href='/pages/fanworks');

  async function auth(){
    const r=await sb.auth.getSession();state.session=r.data?.session||null;state.user=state.session?.user||null;
    $('[data-hof-gc-auth-status]',root).textContent=state.user?`Signed in as ${state.user.email||'Fan'}. Completed games can earn FanScore.`:'You are not signed in. You can see the game catalog, but you must sign in through Hall Of Fan/FanScore before a game can earn points.';
  }
  async function schools(){
    const {data,error}=await sb.from('hof_school_directory_v').select('school_id,school_slug,school_name').order('school_name');
    if(error)throw error;state.schools=data||[];
    const p=query();
    let profileSchoolId='';
    if(state.user){
      const pr=await sb.from('fs_profiles').select('school_id').eq('id',state.user.id).maybeSingle();
      profileSchoolId=pr.data?.school_id||'';
    }
    const id=p.get('school_id')||profileSchoolId||stored('fanscore_school_id');
    const slug=p.get('team')||p.get('team_slug')||stored('fanscore_team_slug');
    state.school=state.schools.find(s=>s.school_id===id)||state.schools.find(s=>s.school_slug===slug)||state.schools[0]||null;
    const sel=$('[data-hof-gc-team]',root);
    sel.innerHTML=state.schools.map(s=>`<option value="${esc(s.school_id)}" ${s.school_id===state.school?.school_id?'selected':''}>${esc(s.school_name)}</option>`).join('');
  }
  async function setSchool(s,persistProfile=true){
    state.school=s;if(!s)return;
    store('fanscore_school_id',s.school_id);store('fanscore_team_slug',s.school_slug);store('nil_arcade_team_slug',s.school_slug);
    if(window.HOFTheme?.setTeam){
      const full=await sb.from('hof_school_directory_v').select('school_id,school_slug,school_name,primary_color,secondary_color,accent_color').eq('school_id',s.school_id).maybeSingle();
      if(full.data)window.HOFTheme.setTeam({id:full.data.school_id,slug:full.data.school_slug,name:full.data.school_name,primary:full.data.primary_color,secondary:full.data.secondary_color||full.data.accent_color});
    }
    if(persistProfile&&state.user){
      const {error}=await sb.from('fs_profiles').update({school_id:s.school_id}).eq('id',state.user.id);
      if(error)throw error;
    }
    await Promise.all([loadCatalog(),loadScore(),loadRecent()]);
  }
  async function loadCatalog(){
    const holder=$('[data-hof-gc-games]',root);holder.textContent='Loading games…';
    if(!state.school){holder.textContent='Choose a team.';return}
    const {data,error}=await sb.rpc('hof_game_center_catalog_v2',{p_school_slug:state.school.school_slug});
    if(error){holder.textContent=`Could not load Game Center: ${error.message}`;return}
    state.catalog=(data||[]).filter(x=>x.enabled!==false);
    if(!state.catalog.length){holder.textContent='No enabled games are configured for this team.';return}
    const grid=document.createElement('div');grid.className='hof-gc-game-grid';
    state.catalog.forEach((g,index)=>{
      const card=document.createElement('article');card.className='hof-gc-game-card';
      const points=Number(g.fanscore_points_per_play||0);
      const cap=Number(g.fanscore_daily_points_cap||0);
      const min=Number(g.fanscore_minimum_duration_ms||0);
      const max=Number(g.max_points_per_play||0),pb=Number(g.personal_best_bonus||0),tiers=Array.isArray(g.performance_tiers)?g.performance_tiers:[];
      const bonus=[];if(pb)bonus.push(`personal best +${pb}`);if(tiers.length)bonus.push('performance bonuses available');
      card.innerHTML=`<div class="hof-gc-game-card__head"><span class="hof-gc-game-number">${String(index+1).padStart(2,'0')}</span><div class="hof-gc-point-badge"><strong>${num(points)}</strong><span>points / play</span></div></div><h3>${esc(g.name)}</h3><p class="hof-gc-game-rule">Daily max ${cap?num(cap):'—'} · minimum play ${(min/1000).toFixed(min%1000?1:0)} sec · max per play ${max?num(max):'—'}${bonus.length?` · ${esc(bonus.join(' · '))}`:''}</p><div class="hof-gc-game-meta">${esc(g.handle)} · ${esc(g.scoring_source||'catalog')}</div><a class="hof-gc-play" href="${esc(withContext(g.launch_url,state.school,home))}">Play ${esc(g.name)} →</a>`;
      grid.appendChild(card);
    });
    holder.replaceChildren(grid);
  }
  async function loadScore(){
    const scoreEl=$('[data-hof-gc-score]',root),detail=$('[data-hof-gc-score-breakdown]',root);
    if(!state.user||!state.school){scoreEl.textContent='0';detail.textContent='Sign in to load your FanScore.';return}
    const {data,error}=await sb.from('hof_my_fanscore_v').select('*').eq('school_id',state.school.school_id).maybeSingle();
    if(error){detail.textContent=`Could not load FanScore: ${error.message}`;return}
    scoreEl.textContent=num(data?.fan_score||0);
    detail.textContent=`Gameplay ${num(data?.gameplay_points)} · Attendance ${num(data?.attendance_points)} · Challenges ${num(data?.challenge_points)} · Partner/Sponsor ${num(data?.sponsor_points)} · Plays ${num(data?.plays_count)}`;
  }
  async function loadRecent(){
    const holder=$('[data-hof-gc-recent]',root);
    if(!state.user||!state.school){holder.textContent='Sign in to see your recent gameplay scoring activity.';return}
    const {data,error}=await sb.from('fs_score_events').select('points,raw_score,occurred_at,metadata,arcade_game_id').eq('user_id',state.user.id).eq('school_id',state.school.school_id).eq('source_type','gameplay').order('occurred_at',{ascending:false}).limit(10);
    if(error){holder.textContent=`Could not load gameplay activity: ${error.message}`;return}
    if(!(data||[]).length){holder.textContent='No gameplay point events yet for this team.';return}
    const ul=document.createElement('ul');ul.className='hof-gc-recent-list';(data||[]).forEach(e=>{const li=document.createElement('li');li.className='hof-gc-recent-item';const name=e.metadata?.game_name||e.metadata?.game_handle||e.metadata?.handle||'Game';li.innerHTML=`<div><strong>${esc(name)}</strong><small>${new Date(e.occurred_at).toLocaleString()}</small></div><span class="hof-gc-recent-points">+${num(e.points)}</span>`;ul.appendChild(li)});holder.replaceChildren(ul);
  }
  $('[data-hof-gc-team]',root).addEventListener('change',async e=>{
    const s=state.schools.find(x=>x.school_id===e.target.value);try{await setSchool(s,true)}catch(err){$('[data-hof-gc-auth-status]',root).textContent=`Team changed locally, but profile sync failed: ${err.message}`}
  });
  $('[data-hof-gc-refresh-score]',root).addEventListener('click',()=>Promise.all([loadScore(),loadRecent()]));
  sb.auth.onAuthStateChange(async(_e,s)=>{state.session=s;state.user=s?.user||null;await auth();await loadScore();await loadRecent()});
  try{await auth();await schools();await setSchool(state.school,false)}catch(err){root.append(document.createTextNode(` Connection error: ${err.message}`))}
}
document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-hof-game-center]').forEach(init));
})();
